export default "__VITE_ASSET__gOzxe65P__"